import {
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
  NgModule,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { CookieModule } from '@gorniv/ngx-universal';
import { CookieService } from 'ngx-cookie-service';

import { AgGridModule } from 'ag-grid-angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { FooterModule } from './shared/footer/footer.module';
import { LeftNavigationModule } from './shared/left-navigation/left-navigation.module';
import { SharedModule } from './shared/shared.module';
import { TopBannerModule } from './shared/top-banner/top-banner.module';

import { AccountManagementModule } from './account-management/account-management.module';
import { PopupsModule } from './popups/popups.module';
import { SettingsModule } from './settings/settings.module';

import { CommonModule } from '@angular/common';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { NgxPageVisibilityModule } from '@ultimate/ngx-pagevisibility';
import { NgxSpinnerModule } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { ForgotPasswordModule } from './forgot-password/forgot-password.module';
import { LoginPageModule } from './login-page/login-page.module';
import { MailModule } from './mail/mail.module';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ProfilePageModule } from './profile-page/profile-page.module';
import { RecoveryModule } from './recovery/recovery.module';
import { RegistrationPageModule } from './registration-page/registration-page.module';
import { AuthInterceptorService } from './services/auth.interceptor.service';
import { ToastComponent } from './shared-new/components/toast/toast.component';
import { SpinnerService } from './shared-new/services/spinner.service';
import { SharedStoreModule } from './shared-new/store/store.module';
import { BackgroundFileUploaderModule } from './shared/background-file-uploader/background-file-uploader.module';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { UserManagementModule } from './user-management/user-management.module';
import { DateParserFormatter } from './utils/helper/date-parser-formatter';

@NgModule({
  declarations: [
    AppComponent,
    ToastComponent,
    TermsAndConditionsComponent,
    PrivacyPolicyComponent,
  ],
  imports: [
    CommonModule,
    CookieModule.forRoot(),
    HttpClientModule,
    BrowserModule,
    NgxPageVisibilityModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AppRoutingModule,
    AgGridModule,
    SharedModule,
    PopupsModule,
    LeftNavigationModule,
    BackgroundFileUploaderModule,
    TopBannerModule,
    FooterModule,
    LoginPageModule,
    ForgotPasswordModule,
    RegistrationPageModule,
    ProfilePageModule,
    UserManagementModule,
    AccountManagementModule,
    NgbModule,
    BrowserAnimationsModule,
    FontAwesomeModule,
    RecoveryModule,
    MailModule,

    StoreModule.forRoot({}, {}),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),
    SharedStoreModule,
    SettingsModule,
    NgxSpinnerModule.forRoot(),
  ],
  exports: [
    CommonModule,
    RouterModule,
    AppRoutingModule,
    LeftNavigationModule,
    BackgroundFileUploaderModule,
    TopBannerModule,
    FooterModule,
  ],
  providers: [
    CookieService,
    SpinnerService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    DateParserFormatter, // Provide CustomDateParserFormatter here
    {
      provide: NgbDateParserFormatter,
      useExisting: DateParserFormatter, // Use the existing instance
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppModule {}
